<template>
  <el-dialog title="创建订单" :visible.sync="dialogVisible" width="600px" center destroy-on-close @closed="resetForm">
    <el-form :model="editForm" label-width="123px">
      <el-form-item label="姓名">
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="editForm.sex">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="年龄">
        <el-input v-model="editForm.age" autocomplete="off" type="number"></el-input>
      </el-form-item>
      <el-form-item label="监护人电话">
        <el-input v-model="editForm.tel" autocomplete="off" maxlength="11"></el-input>
      </el-form-item>
      <el-form-item label="服务类型">
        <el-select v-model="editForm.cri_type" placeholder="请选择服务类型">
          <el-option label="日间照料" value="1"></el-option>
          <el-option label="寄宿托养" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="残疾证号">
        <el-input v-model="editForm.id_card" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="残疾等级">
        <el-select v-model="editForm.dis_grade" placeholder="请选择残疾等级" clearable>
          <el-option label="一级" value="1"></el-option>
          <el-option label="二级" value="2"></el-option>
          <el-option label="三级" value="3"></el-option>
          <el-option label="四级" value="4"></el-option>
          <el-option label="未分级" value="5"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input v-model="editForm.address" autocomplete="off" type="textarea" :rows="2"></el-input>
      </el-form-item>
      <el-form-item label="残疾证照" label-position="top">
        <el-upload
          action='#'
          :http-request="uploadFile"
          list-type="picture-card"
          :limit="9"
          :file-list="fileList"
          :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pictureCompress from 'picture-compressor'
import { createBoardingOrder, uploadImgs } from '../../../api'

export default {
  name: 'BoardingCreateOrder',
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      editForm: {
        name: '',
        sex: '',
        age: '',
        tel: '',
        cri_type: '1',
        id_card: '',
        address: '',
        dis_grade: ''
      },
      fileList: []
    }
  },
  methods: {
    open() {
      this.resetForm()
      this.dialogVisible = true
    },
    resetForm() {
      this.editForm = {
        name: '',
        sex: '',
        age: '',
        tel: '',
        cri_type: '1',
        id_card: '',
        address: '',
        dis_grade: ''
      }
      this.fileList = []
    },
    handleRemove(file) {
      this.fileList.map((fileData, key) => {
        if (fileData.uid === file.uid) {
          this.fileList.splice(key, 1)
        }
      })
    },
    uploadFile(item) {
      const _this = this
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      reader.onload = function() {
        pictureCompress({
          img: reader.result,
          width: 500,
          height: 500
        }).then(res => {
          const params = {
            data: res.img,
            fileName: item.file.uid
          }
          uploadImgs(params)
            .then(resp => {
              if (resp.status) {
                _this.fileList.push({ uid: item.file.uid, ...resp.data })
              }
            })
            .catch(() => {})
        })
      }
    },
    handleSubmit() {
      const { id_card, name, tel, address, dis_grade, sex, age, cri_type } = this.editForm
      const img_urls = this.fileList.map(fileData => fileData.url).join(',')
      if (!name) return this.$message({ message: '请填写姓名！', type: 'warning' })
      if (!sex) return this.$message({ message: '请选择性别！', type: 'warning' })
      if (!tel) return this.$message({ message: '请填写监护人电话！', type: 'warning' })
      if (!cri_type) return this.$message({ message: '请选择服务类型！', type: 'warning' })
      if (!address) return this.$message({ message: '请填写详细地址！', type: 'warning' })
      const params = {
        name,
        tel,
        address,
        sex,
        age,
        cri_type,
        id_card,
        dis_grade,
        img_urls
      }
      this.submitLoading = true
      createBoardingOrder(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg || '创建成功')
          this.handleClose()
          this.$emit('success')
        } else {
          this.$message.error(res.msg || '创建失败')
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>
</style>
